<template>
  <section class="suggestion-table-container">
    <SuggestionTableItem
      v-for="(item, name) of topIssues.weekIssues"
      :key="name"
      :title="`top ${name.substring(0, name.length - 1)} of the week`"
      :issue="item"
  />
    <SuggestionTableItem
      v-for="(item, name) of topIssues.monthIssues"
      :key="name + 1"
      :title="`top ${name.substring(0, name.length - 1)} of the month`"
      :issue="item"
    />
  </section>
</template>

<script>
import SuggestionTableItem from './SuggestionTableItem';

export default {
  props: {
    topIssues: { type: Object, required: true },
  },
  components: {
    SuggestionTableItem
  }
}
</script>

<style lang="scss" scoped>
.suggestion-table-container {
  display: grid;
  gap: 20px;
  width: 100%;
  
  // Mobile: Single column
  grid-template-columns: 1fr;
  
  // Small tablets: 2 columns
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  
  // Large tablets and desktop: 3 columns
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  
  // Extra large screens: maintain 3 columns with max width
  @media (min-width: 1440px) {
    margin: 0 auto;
  }
  
  // Handle fewer items gracefully
  &:has(> :nth-child(1):last-child) {
    // Only 1 item
    @media (min-width: 768px) {
      grid-template-columns: 1fr;
      margin: 0 auto;
    }
  }
  
  &:has(> :nth-child(2):last-child) {
    // Only 2 items
    @media (min-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      margin: 0 auto;
    }
  }
}

// Alternative approach for browsers that don't support :has()
.suggestion-table-container[data-item-count="1"] {
  @media (min-width: 768px) {
    grid-template-columns: 1fr;
    margin: 0 auto;
  }
}

.suggestion-table-container[data-item-count="2"] {
  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 auto;
  }
}
</style>